import { ICourseStructureCategoryBreadcrumbQuery } from '../interfaces/course-structure-category-breadcrumb.query.interface';

export class CourseStructureCategoryBreadcrumb {
    id: string;
    name: string;
    type: string;

    constructor(query: ICourseStructureCategoryBreadcrumbQuery) {
        this.id = query.id.toString();
        this.name = query.name;
        this.type = query.type;
    }
}
